import { render, staticRenderFns } from "./formPermissions.vue?vue&type=template&id=1692a398&scoped=true&"
import script from "./formPermissions.vue?vue&type=script&lang=js&"
export * from "./formPermissions.vue?vue&type=script&lang=js&"
import style0 from "./formPermissions.vue?vue&type=style&index=0&id=1692a398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1692a398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1692a398')) {
      api.createRecord('1692a398', component.options)
    } else {
      api.reload('1692a398', component.options)
    }
    module.hot.accept("./formPermissions.vue?vue&type=template&id=1692a398&scoped=true&", function () {
      api.rerender('1692a398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/form-permissions/formPermissions.vue"
export default component.exports